import type { Client } from "../types";
import { ClientCreate } from "./ClientCreate";
import { ClientEdit } from "./ClientEdit";
import { ClientList } from "./ClientList";
import { ClientShow } from "./ClientShow";

/**
 * ASSUMPTION (Almikia Epic E3): desktop only — clients are not added to the
 * mobile app in this ticket.
 */
export default {
  list: ClientList,
  show: ClientShow,
  create: ClientCreate,
  edit: ClientEdit,
  recordRepresentation: (record: Client) => record.full_legal_name,
};
